exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.notifications-announcement{position:absolute;top:0;bottom:0;height:100%;width:100%;opacity:1;z-index:9999}.notifications-announcement--slow-fade{opacity:0;transition:opacity 1.5s .5s}.notifications-announcement--quick-fade{opacity:0;transition:opacity .5s}.notifications-announcement__no-thanks{cursor:pointer;height:24px;margin-bottom:10%;margin-top:auto}.notifications-announcement__no-thanks__button{background:none;border:none;color:#184e78;text-align:center;font-family:Open Sans,sans-serif;font-weight:300;font-size:18px;height:100%;width:100%}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/components/modals/AnnouncementModal/NotificationsAnnouncementModal/NotificationsAnnouncementModal.scss
// module id = 1700
// module chunks = 0